import React, { useState, useEffect } from "react";
import { getLoggedInUser } from "../helpers";
import {
  Container,
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import swal from "sweetalert";
import Loader from "./Loader/Loader";
import config from "react-global-configuration";
import "react-datepicker/dist/react-datepicker.css";
import "../assets/scss/_common.scss";
import Wallet from "../pages/Wallet";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "react-i18next";

const Gameplayprofile = (props) => {
  const { t } = useTranslation();
  const [user, setUser] = useState(getLoggedInUser());
  const [totalCashBalance, setTotalCashBalance] = useState("");
  const [totalNonCash, setTotalNonCash] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(-1);
  const [pageSize, setPageSize] = useState(10);
  const [pageSizeOptions] = useState([10, 20, 30, 40, 50, 100]);
  const [currentPage, setCurrentPage] = useState(0);
  const [tableSorting, setTableSorting] = useState([
    { columnName: "title", direction: "asc" },
  ]);
  const [tableFilter, setTableFilter] = useState([]);
  const [bettingLimit, setBettingLimit] = useState("");
  const [resMessage, setResMessage] = useState("");
  const [right, setRight] = useState(false);
  const [wrong, setWrong] = useState(false);
  const [userList, setUserList] = useState([]);
  const [walletList, setWalletList] = useState([]);
  const [totalBalance, setTotalBalance] = useState("");
  const [totalDeposit, setTotalDeposit] = useState("");
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [manageUserService, setManageUserService] = useState("");
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [depositModalOpen, setDepositModalOpen] = useState(false);
  const [iframeMode, setIframeMode] = useState(false);

  useEffect(() => {
    loadRecordsTables();
    loadUserWalletTables();
    manageUserServices();
  }, []);

  const loadRecordsTables = () => {
    const reqData = { guid: user.guid };

    setIsLoading(true);
    betSlipService
      .LimitDetails(reqData)
      .then((res) => {
        setIsLoading(false);
        setUserList(res[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        // Handle error
      });
  };

  const loadUserWalletTables = () => {
    const columnSorting = tableSorting[0];
    let curPage = currentPage + 1;
    const reqData = {
      guid: user.guid,
      page_size: pageSize,
      page: curPage,
      search: tableFilter,
    };
    if (columnSorting) {
      reqData.sort_by = columnSorting.columnName;
      reqData.sort_order = columnSorting.direction === "desc" ? "desc" : "asc";
    }
    setIsLoading(true);
    betSlipService
      .userGameplay(reqData)
      .then((response) => {
        setIsLoading(false);
        setWalletList(response.user_transaction.data);
        setTotalItemCount(response.user_transaction.total);
        setTotalPageCount(response.user_transaction.last_page);
        setTotalBalance(response.total_balance);
        setTotalCashBalance(response.total_cash_balance);
        setTotalNonCash(response.total_non_cash_balance);
        setTotalDeposit(response.total_deposit);
      })
      .catch((error) => {
        setIsLoading(false);
        // Handle error
      });
  };

  const manageUserServices = () => {
    const reqData = { guid: user?.guid || "" };
    betSlipService
      .manageuserServices(reqData)
      .then((response) => {
        setManageUserService(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleValidSubmit = (event, values) => {
    setIsLoading(true);

    let formData = new FormData();
    formData.append("betting_limit", values.betting_limit);
    formData.append("password", values.password);
    formData.append("guid", user.guid);

    betSlipService
      .updateLimit(formData, config)
      .then((res) => {
        if (res.message) {
          setRight(true);
          setResMessage(res.message);
        } else {
          setWrong(true);
          setResMessage(res.error);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        // Handle error
      });
  };

  const onDismiss = () => {
    setRight(false);
    setWrong(false);
  };

  const openDepositModal = () => {
    setDepositModalOpen(true);
  };

  const closeDepositModal = () => {
    setDepositModalOpen(false);
  };

  const handlePerRowsChange = (perPage) => {
    setPageSize(perPage);
    loadUserWalletTables();
  };

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
    loadUserWalletTables();
  };

  const handleSortChange = (tableSorting) => {
    const sortVal = tableSorting.map((value) => ({
      columnName: value.id,
      direction: value.desc ? "desc" : "asc",
    }));
    setTableSorting(sortVal);
    loadUserWalletTables();
  };

  const handleFilterChange = (tableFilter) => {
    setTableFilter(tableFilter);
    loadUserWalletTables();
  };
  const onTrigger = (event) => {
    props.parentCallback(true);
  };
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      {
        <div className="account-pages">
          <Modal
            // className="withdraw-request-popup"
            className={`withdraw-request-popup ${iframeMode ? "modal-full" : ""}`}
            isOpen={depositModalOpen}
            // toggle={closeDepositModal}
          >
            {/* <ModalHeader toggle={closeDepositModal}></ModalHeader> */}
            <ModalBody>
              <Wallet
                setDepositModalOpen={setDepositModalOpen}
                setIframeMode={setIframeMode}
              />
            </ModalBody>

            <p onClick={closeDepositModal}>
              <RxCross2 className="close-btn" />
            </p>
          </Modal>

          <section className="dashboard-section padding-top padding-bottom">
            <Container>
              <Row>
                <Col className="col-lg-12 col-md-12 col-sm-12">
                  <div className="user-toggler-wrapper d-flex align-items-center d-lg-none">
                    <h4 className="title m-0">Menu</h4>
                    <div className="user-toggler" onClick={() => onTrigger()}>
                      <i className="las la-sliders-h"></i>
                    </div>
                  </div>
                  <Row
                    className=" justify-content-center"
                    style={{ marginTop: "auto" }}
                  >
                    <div className="col-lg-4 col-xl-4 col-md-4 col-sm-10">
                      <div className="dashboard__card">
                        <div className="dashboard__card-content">
                          <h2 className="price">
                            €{totalBalance ? totalBalance : "0.00"}
                          </h2>
                          <p className="info">
                            {t("userProfile.gameHistory.totalBalance")}
                          </p>
                          <a className="view-btn">
                            {t("userProfile.gameHistory.viewAll")}
                          </a>
                        </div>
                        {/* <div className="dashboard__card-icon">
                                                        <i className="las la-wallet"></i>
                                                    </div> */}
                      </div>
                    </div>
                    <div className="col-lg-4 col-xl-4 col-md-4 col-sm-10">
                      <div className="dashboard__card">
                        <div className="dashboard__card-content">
                          <h2 className="price">
                            €{totalCashBalance ? totalCashBalance : "0.00"}
                          </h2>
                          <p className="info">
                            {t("userProfile.gameHistory.cashBalance")}
                          </p>

                          {(() => {
                            if (manageUserService.deposit_status == 0) {
                              return (
                                <a
                                  className="view-btn"
                                  onClick={() =>
                                    swal({
                                      icon: "info",
                                      title: "Note",
                                      text: "Your Deposit process has been paused by the admin. If you wish to proceed, please contact our administrator on admin@stotngo.com.",
                                      confirmButtonText: "OK",
                                    })
                                  }
                                >
                                  {t("userProfile.gameHistory.deposit")}
                                </a>
                              );
                            } else {
                              return (
                                <a
                                  className="view-btn"
                                  onClick={openDepositModal}
                                >
                                  {t("userProfile.gameHistory.deposit")}
                                </a>
                              );
                            }
                          })()}
                        </div>
                        {/* <div className="dashboard__card-icon">
                                                        <i className="las la-wallet"></i>
                                                    </div> */}
                      </div>
                    </div>
                    <div className="col-lg-4 col-xl-4 col-md-4 col-sm-10">
                      <div className="dashboard__card">
                        <div className="dashboard__card-content">
                          <h2 className="price">
                            €{totalNonCash ? totalNonCash : "0.00"}
                          </h2>
                          <p className="info">
                            {t("userProfile.gameHistory.nonCashBalance")}
                          </p>
                          <a className="view-btn">
                            {t("userProfile.gameHistory.viewAll")}
                          </a>
                        </div>
                        {/* <div className="dashboard__card-icon">
                                                        <i className="las la-wallet"></i>
                                                    </div> */}
                      </div>
                    </div>
                  </Row>
                  <div className="table--responsive--md mt-3">
                    <Card style={{ minHeight: "425px" }}>
                      <CardBody className="bg-dark1  user-data">
                        <ReactTable
                          data={walletList}
                          columns={[
                            {
                              Header: t("userProfile.gameHistory.gameName"),
                              accessor: "GameType",
                              filterable: false,
                              sortable: false,
                              className: "text-center",
                              Cell: (row) => (
                                <span>{row.value ? row.value : "--"}</span>
                              ),
                            },

                            {
                              Header: t(
                                "userProfile.gameHistory.transactionType",
                              ),
                              accessor: "type",
                              filterable: false,
                              sortable: false,
                              className: "text-center",
                              Cell: (row) => (
                                <span>{row.value ? row.value : "--"}</span>
                              ),
                            },
                            {
                              Header: t("userProfile.gameHistory.amountType"),
                              accessor: "amount_type",
                              filterable: false,
                              sortable: false,
                              className: "text-center",
                              Cell: (row) => (
                                <span>
                                  {row.value ? "" : ""}
                                  {row.value ? row.value : "--"}
                                </span>
                              ),
                            },
                            {
                              Header: t("userProfile.gameHistory.amount"),
                              accessor: "amount",
                              filterable: false,
                              sortable: false,
                              className: "text-center",
                              Cell: (row) => (
                                <span>
                                  {row.value ? "€" : ""}
                                  {row.value ? row.value : "--"}
                                </span>
                              ),
                            },
                            {
                              Header: t("userProfile.gameHistory.dateTime"),
                              accessor: "created_date",
                              filterable: false,
                              sortable: false,
                              className: "text-center",
                              Cell: (row) => (
                                <span>{row.value ? row.value : "--"}</span>
                              ),
                            },
                            // {
                            //     Header: "Transaction ID",
                            //     accessor: "transaction_detail.rgs_trnasction_id",
                            //     filterable: false,
                            //     sortable: false,
                            //     className: "text-center",
                            //     Cell: row => <span>{row.value ? row.value : '--'}</span>,
                            //     width: 290,
                            // },
                          ]}
                          loading={isLoading}
                          defaultPageSize={pageSize}
                          pageSizeOptions={pageSizeOptions}
                          sortable={true}
                          multiSort={false}
                          resizable={true}
                          filterable={true}
                          onSortedChange={handleSortChange}
                          onPageSizeChange={handlePerRowsChange}
                          onPageChange={handlePageChange}
                          onFilteredChange={handleFilterChange}
                          manual={true}
                          minRows="0"
                          pages={totalPageCount}
                          showPagination={walletList.length > 0}
                          NoDataComponent={() => (
                            <div
                              style={{
                                textAlign: "center",
                                padding: "1rem",
                              }}
                            >
                              {t("userProfile.gameHistory.noGames")}
                            </div>
                          )}
                        />
                      </CardBody>
                    </Card>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      }
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return user;
};
export default connect(mapStateToProps)(Gameplayprofile);
